export default "__VITE_ASSET__B9$tp2bW__"